//#region src/utils/mergeClassNameOverrides.ts
var e = (e) => e.split(" ").map((e) => e.trim()).filter(Boolean), t = (e, t, n) => ({
	kind: e,
	axis: t,
	value: n
}), n = (e) => {
	let t = e.match(/^(margin|padding)(?:-(x|y|top|right|bottom|left))?-(.+)$/);
	return t ? {
		kind: t[1],
		axis: t[2] ?? "all",
		value: t[3]
	} : null;
}, r = ({ kind: e, axis: t, value: n }) => t === "all" ? `${e}-${n}` : `${e}-${t}-${n}`, i = (e, t) => t === "all" || e === "all" || e === t || e === "x" && (t === "left" || t === "right") || e === "y" && (t === "top" || t === "bottom") || t === "x" && (e === "left" || e === "right") || t === "y" && (e === "top" || e === "bottom"), a = (e) => {
	if (e.startsWith("margin-")) {
		let [t, n] = e.split("-");
		return n === "x" || n === "y" || n === "top" || n === "right" || n === "bottom" || n === "left" ? `${t}-${n}` : t;
	}
	if (e.startsWith("padding-")) {
		let [t, n] = e.split("-");
		return n === "x" || n === "y" || n === "top" || n === "right" || n === "bottom" || n === "left" ? `${t}-${n}` : t;
	}
	return e.startsWith("text-size-") ? "text-size" : e.startsWith("text-color-") ? "text-color" : e.startsWith("bg-") ? "bg" : e.startsWith("max-width-") ? "max-width" : e.startsWith("min-width-") ? "min-width" : e.startsWith("width-") ? "width" : e.startsWith("max-height-") ? "max-height" : e.startsWith("min-height-") ? "min-height" : e.startsWith("height-") ? "height" : e.startsWith("shadow-") ? "shadow" : e === "rounded" || e.startsWith("rounded-") ? "rounded" : e === "border" || e.startsWith("border-") ? "border" : e;
}, o = (o, s) => {
	if (!s || s.trim() === "") return o;
	let c = e(s), l = new Set(c.map((e) => a(e))), u = c.map(n).filter(Boolean), d = {
		margin: u.filter((e) => e.kind === "margin").map((e) => e.axis),
		padding: u.filter((e) => e.kind === "padding").map((e) => e.axis)
	}, f = e(o), p = [], m = f.filter((e) => {
		let t = n(e);
		return t ? !d[t.kind].some((e) => i(t.axis, e)) || (p.push(t), !1) : !l.has(a(e));
	}), h = p.filter((e) => e.axis === "x" || e.axis === "y").flatMap((e) => {
		let n = d[e.kind];
		if (n.includes("all") || n.includes(e.axis)) return [];
		if (e.axis === "x") {
			let r = n.includes("left"), i = n.includes("right");
			if (r && !i) return [t(e.kind, "right", e.value)];
			if (i && !r) return [t(e.kind, "left", e.value)];
		}
		if (e.axis === "y") {
			let r = n.includes("top"), i = n.includes("bottom");
			if (r && !i) return [t(e.kind, "bottom", e.value)];
			if (i && !r) return [t(e.kind, "top", e.value)];
		}
		return [];
	}).map(r), g = /* @__PURE__ */ new Set([...m, ...c]), _ = h.filter((e) => !g.has(e) && (g.add(e), !0));
	return [
		...m,
		..._,
		...c
	].join(" ");
};
//#endregion
export { o as mergeClassNameOverrides };

//# sourceMappingURL=mergeClassNameOverrides.js.map